<template><!--个人中心》我的余额》提现-->
    <div class="withdrawPage">
        <div class="mybal-box">
            <div class="userrec-wid dis-between" style="padding:0 24px">
                <div>提现<span class="withdra-color">&nbsp;&nbsp;&nbsp;&nbsp;单笔提现手续费扣除10元！</span></div>
                <div @click="routerTxClick" style="color:#11D165;cursor: pointer;">提现记录</div>
            </div>
        </div>
        <div class="mybal-box" style="padding:0 24px 24px 24px">
            <div class="withdra-wid dis">
                <div class="withdra-color dis-end">选择提现银行卡：&nbsp;&nbsp;&nbsp;&nbsp;</div>
                <div class="dis-between withdra-he" :class="is_setbank?'withdra-bor-act':''" style="width:82%;border-radius:4px" @click="setBank">
                    <div class="withdra-p" style="width:85%;padding:0 24px">
                        <div v-if="bankListData.length > 0" class="dis"><div>{{bankObj.bankName}}</div><div style="margin-left:25px;">{{bankObj.cardno}}</div><div style="margin-left:25px;">{{bankObj.cardname}}</div></div>
                        <div v-else>暂无银行卡信息，请添加</div>
                    </div>
                    <div class="withdra-xian" :class="is_setbank?'withdra-xian-act':''"></div>
                    <div style="width:14%;text-align: center;"><img class="withdra-img" src="../../../assets/image/iocn/FANHUI.png" /></div>
                </div>
            </div>
            <div style="font-size: 14px;color: #999999;margin:8px 0 24px 156px;">提现申请成功后，会在1-3个工作日内到您的银行卡账户，造成不便请谅解哦~</div>
            <div v-if="is_setbank" class="withdra-bank-pos">
                <div class="withdra-wid dis">
                    <div class="withdra-color dis-end"></div>
                    <div class="dis withdra-he" style="width:714px;;height:auto;background:#ffffff">
                        <div class="withdra-title">选择提现银行卡</div>
                        <!---->
                        <div class="test-1" style="width:100%;height:250px;overflow-y: scroll;">
                            <div class="withdra-bank-he" style="height:auto" v-for="(item, index) in bankListData" :key="index">
                                <div class="withdra-bank-he-box dis" style="height:82px" @click="bankClick(item.id, index)">
                                    <div class="dis" style="width:85%;line-height:82px;color:#999999">
                                        <div>{{item.bankName}}</div><div style="margin-left:25px;">{{item.cardno}}</div><div style="margin-left:25px;">{{item.cardname}}</div>
                                    </div>
                                    <div style="width:14%;text-align: center;"><img v-if="is_act == item.id" class="withdra-img2" src="../../../assets/image/iocn/XYANZHE.png" /></div>
                                </div>
                            </div>
                        </div>
                        <div class="withdra-bank-he" style="height:auto" @click="addCardClick">
                            <div class="withdra-bank-he-box dis" style="height:82px">
                                <div class="dis" style="width:85%;line-height:82px;color:#999999">
                                    <img class="withdra-img3" src="../../../assets/image/iocn/yhk.png" /><div style="margin-left:25px;">使用新卡提现</div>
                                </div>
                                <div style="width:14%;text-align: center;"></div>
                            </div>
                        </div>
                        
                        <div v-if="bankListData.length > 0" class="withdra-but-ok" @click="okClick">确认</div>
                    </div>
                </div>
            </div>

            <div class="withdra-wid dis" style="margin-top:24px">
                <div class="withdra-color dis-end">可提现金额：&nbsp;&nbsp;&nbsp;&nbsp;</div>
                <div class="dis withdra-he" style="width:82%;border:none">
                   <el-input style="width:160px" type="number" v-model="money" :placeholder="p_value"></el-input>
                   <div class="withdra-color">&nbsp;&nbsp;&nbsp;&nbsp;元</div>
                </div>
            </div>
            <div class="withdra-wid dis" style="margin-top:24px">
                <div class="withdra-color dis-end">支付密码：&nbsp;&nbsp;&nbsp;&nbsp;</div>
                <div class="dis withdra-he" style="width:82%;border:none">
                   <el-input style="width:160px" type="password" v-model="password"></el-input>
                   <div class="withdra-color" @click="wjpasswordClick">&nbsp;&nbsp;&nbsp;&nbsp;忘记密码</div>
                </div>
            </div>
            <div class="withdra-wid dis" style="margin-top:24px">
                <div class="withdra-color dis-end"></div>
                <div class="dis withdra-he" style="width:82%;border:none">
                   <div v-if="!is_butClick" class="withdra-color withdra-but" @click="butClick">确认提现</div>
                   <div v-else class="withdra-color withdra-but" style="background:#cacaca">加载中...</div>
                </div>
            </div>



        </div>
        <!--请输入支付密码-->
        <div
            class="reg-popup-bac req-popup-pos"
            v-if="is_zhifuPopup"
        ></div>
        <div
            class="req-popup-pos reg-popup-wid dis-cen"
            v-if="is_zhifuPopup"
        >
            <div class="reg-popup-box" style="height:auto;border-radius:0">
                <div class="dis-between">
                    <div @click="wjpasswordClick" style="color:#11D165;cursor: pointer;">设置支付密码</div>
                    <div style="font-size: 22px;">添加银行卡</div>
                    <div class="dis-end" style="width:96px"><img class="reg-popup-box-close" style="cursor: pointer;" @click="closePopupImgClick" src="../../../assets/image/iocn/close.png" /></div>
                </div>
                <div style="font-size: 18px;text-align: center;margin-top:19px">请输入支付密码，以验证身份</div>
                <div id="payPwd" style="margin: 60px 15%">
                    <input ref="pwd" type="password" maxlength="6" v-model="msg"  style="position: absolute;z-index: -1;left:-100%;opacity: 0"/>
                    <ul class="pwd-wrap" @click="focus">
                    <li><i v-if="msgLength > 0"></i></li>
                    <li><i v-if="msgLength > 1"></i></li>
                    <li><i v-if="msgLength > 2"></i></li>
                    <li><i v-if="msgLength > 3"></i></li>
                    <li><i v-if="msgLength > 4"></i></li>
                    <li><i v-if="msgLength > 5"></i></li>
                    </ul>
                </div>
                <div class="dis-cen">
                    <div class="withdra-color withdra-but" @click="checkClick">确认密码</div>
                </div>
            </div>
        </div>
        <!--温馨提示-->
        <div
            class="reg-popup-bac req-popup-pos"
            v-if="is_Popup"
        ></div>
        <div
            class="req-popup-pos reg-popup-wid dis-cen"
            v-if="is_Popup"
        >
            <div class="reg-popup-box" style="height:auto;border-radius:0">
                <div class="dis-between">
                    <div style="width:96px"></div>
                    <div style="font-size: 22px;">温馨提示</div>
                    <div class="dis-end" style="width:96px"><img class="reg-popup-box-close" style="cursor: pointer;" @click="readFn" src="../../../assets/image/iocn/close.png" /></div>
                </div>
                <div style="margin: 60px 15%;font-size:25px">
                    提现已成功，是否继续提现？
                </div>
                <div class="dis-cen" style="width:100%">
                    <div class="dis" style="margin-top:23px">
                        <div class="details-info-wid-botton" style="background: #11D165;" @click="readFn">确定</div>
                        <div class="details-info-wid-botton2" style="line-height:38px" @click="routerTxClick">提现记录</div>
                    </div>
                </div>
            </div>
        </div>

        <!--添加银行卡-->

        <div
            class="reg-popup-bac req-popup-pos"
            v-if="is_cardPopup"
        ></div>
        <div
            class="req-popup-pos reg-popup-wid dis-cen"
            v-if="is_cardPopup"
        >
            <div class="reg-popup-box" style="height:auto;border-radius:0">
                <div class="dis-between">
                    <div></div>
                    <div style="font-size: 22px;">添加银行卡</div>
                    <img class="reg-popup-box-close" @click="closePopupImgClick2" src="../../../assets/image/iocn/close.png" />
                </div>
                <div style="font-size: 18px;text-align: center;margin-top:19px">请绑定持卡人本人的银行卡</div>
                <div style="width:60%;margin:40px 20% 40px 20%">
                    <el-form
                        ref="form"
                        :model="form"
                        label-width="90px"
                    >
                        <el-form-item label="持卡人">
                            <el-input
                                v-model="form.CardName"
                                placeholder="请输入真实姓名"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="卡号">
                            <el-input
                                type="number"
                                v-model="form.CardNo"
                                placeholder="请输入银行卡号"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="卡类型">
                            <el-select
                                v-model="form.BankId"
                                placeholder="请选择卡类型"
                                style="width:100%"
                            >
                                <div
                                    v-for="(item, index) in bankListData"
                                    :key="index"
                                >
                                    <el-option
                                        :label="item.label"
                                        :value="item.value"
                                    ></el-option>
                                </div>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="开户网点">
                            <el-input
                                v-model="form.opening_bank"
                                placeholder="请输入开户网点"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="区域">
                            <el-select
                                v-model="form.type"
                                placeholder="请选择卡属区域"
                                style="width:100%"
                            >
                                <div
                                    v-for="(item, index) in card_area"
                                    :key="index"
                                >
                                    <el-option
                                        :label="item.label"
                                        :value="item.value"
                                    ></el-option>
                                </div>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="手机号">
                            <el-input
                                type="number"
                                v-model="form.Phone"
                                oninput="if(value.length>11)value=value.slice(0,11)"
                                placeholder="银行预留手机号"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="dis-cen">
                    <div class="withdra-color withdra-but" @click="addCardFormClick">确认添加</div>
                </div>
            </div>
        </div>

    </div>
</template>

<style scoped>
    .userrec-wid{width:100%;line-height:56px;background: #F1F1F1;font-size: 18px;padding-left:24px;font-family: PingFang SC;font-weight: 500;color: #434343;line-height: 56px;}
     #payPwd .pwd-wrap{
    /* width: 90%; */
    height: 44px;
    padding-bottom: 1px;
    margin: 0 auto;
    background: #fff;
    /* border:1px solid #ddd; */
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
    cursor: pointer;
  }
  .pwd-wrap li{
    list-style-type:none;
    text-align: center;
    line-height: 44px;
    -webkit-box-flex: 1;
    flex: 1;
    -webkit-flex: 1;
    /* border-right:1px solid #ddd ; */
    background: #f2f2f2;
    margin: 0 10px;
  }
  .pwd-wrap li:last-child{
    border-right: 0;
  }
  .pwd-wrap li i{
    height: 10px;
    width: 10px;
    border-radius:50% ;
    background: #000;
    display: inline-block;
  }


</style>

<script>
    export default
    {
        name: 'withdrawPage',
        props: { parentName: { type: Object } },
        data()
        {
            return {
                is_Popup: false,
                is_cardPopup: false,
                is_zhifuPopup: false,
                is_setbank: false,
                p_value: '可用金额0',
                myBalance: {},
                money: '',
                password: '',
                msg:'',
                msgLength: 0,
                card_area: [
                    {label:'浙江省', value: 0},
                    {label:'其它省', value: 1}
                ],
                bankListData: [],
                is_act: -1,
                bankObj: {},
                form:
                {
                    CardName: '',
                    CardNo: '',
                    UserId: '',
                    BankId: '',
                    Phone: ''
                },
                is_butClick: false,
                //+--------------------------------------------------------
                bol: false,
            };
        },
        watch:{
            msg(curVal){
                if(/[^\d]/g.test(curVal)){
                this.msg = this.msg.replace(/[^\d]/g,'');
                }else{
                    this.msgLength = curVal.length;
                }
            },
        },
        created()
        {
            this.init()
            this.getBalance()
        },
        methods:
        {
            init() {
                let inputData = { PageNo:1, PageSize:30 }
                this.$api.product.GetUserBankList(inputData).then((res) => {
                    this.bankListData = res.data.result.data
                    for(let i = 0; i < this.bankListData.length; i++){
                        if (this.bankListData[i].isdefault) {
                            this.bankObj = this.bankListData[i]
                            this.is_act = this.bankListData[i].id
                        }
                    }
                })
            },
            getBalance() {
                this.$api.order.UserBalances().then(res => {
                    if (res.data.code == 0) {
                        this.myBalance = res.data.result
                        this.p_value = '可用金额 ' + this.myBalance.balance
                    } else {
                        let name = res.data.message
                        this.checkTips(name, "warning")
                    }
                })
            },
            bankClick(id, idx) {
                this.is_act = id
                this.bankObj = this.bankListData[idx]
            },
            wjpasswordClick() {
                this.closeaddress(4)
            },
            setBank() {
                this.is_setbank = !this.is_setbank
            },
            okClick() {
                this.is_setbank = false
            },
            addCardClick() {
                this.is_setbank = false
                this.is_zhifuPopup = true
            },
            closePopupImgClick() {
                this.msg = ''
                this.is_zhifuPopup = false
                this.is_Popup = false

            },
            closePopupImgClick2() {

                this.is_cardPopup = false
                this.init()
            },
            focus(){
                this.$refs.pwd.focus();
            },
            checkClick() {
               console.log(this.msg)
               let params = {PayPwd: this.msg}
               this.$api.product.VerifyPayPwd(params).then((res) => {
                    if ( res.data.code == 0 )
                    {
                        this.is_cardPopup = true
                        this.closePopupImgClick()

                        this.$api.user.bankList().then( res =>
                        {
                            if ( res.data.code == 0 )
                            {
                                let a = res.data.result
                                let b = []
                                let c = {}
                                for ( let i = 0; i < a.length; i++ )
                                {
                                    c = { label: a[ i ].bankname, value: a[ i ].id }
                                    b.push( c )
                                }
                                this.bankListData = b
                            }
                            else
                            {
                                let name = res.data.message;
                                this.checkTips( name, 'warning' );
                            }
                        } )
                    }
                    else
                    {
                        let name = res.data.message;
                        this.checkTips( name, 'warning' );
                    }
               })
            },
            addCardFormClick() {
                let telReg = /^1[3|4|5|6|7|8|9]\d{9}$/;

                if ( this.form.CardName == '' )
                {
                    this.checkTips( '请输入真实姓名', 'warning' );
                    return
                }
                else if ( this.form.CardNo == '' )
                {
                    this.checkTips( '请输入银行卡号', 'warning' );
                    return
                }
                else if ( this.form.BankId == '' )
                {
                    this.checkTips( '请选择卡类型', 'warning' );
                    return
                }
                else if ( this.form.BankId !== 1 && this.form.opening_bank == undefined )
                {
                    this.checkTips( '请输入开户网点', 'warning' );
                    return
                }
                else if ( this.form.BankId !== 1 && this.form.opening_bank == '' )
                {
                    this.checkTips( '请输入开户网点', 'warning' );
                    return
                }
                else if ( this.form.type == undefined || !this.form.type.toString() )
                {
                    this.checkTips( '请选择卡属区域', 'warning' );
                    return
                }
                else if ( this.form.Phone == '' )
                {
                    this.checkTips( '请输入银行卡预留手机号', 'warning' );
                    return
                }
                else if ( !telReg.test( this.form.Phone ) )
                {
                    this.checkTips( '手机号格式错误！', 'warning' );
                    return
                }


                let loginDataObj = JSON.parse( localStorage.getItem( 'loginData' ) )
                this.form.UserId = loginDataObj.userId
                
                console.log( this.form )

                // 提交
                this.$api.user.bankAdd( this.form ).then( res =>
                {
                    if ( res.data.code == 0 )
                    {
                        this.checkTips( '银行卡添加成功', 'success' );
                        this.closePopupImgClick2()
                    }
                    else
                    {
                        let name = res.data.message;
                        this.checkTips( name, 'warning' );
                    }
                } )
            },
            butClick() {
                // if (this.bankObj.bankName !== '中国工商银行') {
                //     this.$alert('提现银行卡只能选择工商银行卡', '温馨提示', {
                //         confirmButtonText: '确定',
                //         callback: action => {
                //             // ...
                //         }
                //     })
                //     return
                // }
                this.reqFn()
            },
            reqFn() {
                if ( this.money > this.myBalance.balance) {
                    this.checkTips( "提现金额不可大于余额", 'warning' );
                    return
                }
                if (!this.money || this.money < 100 || this.money % 10 > 0) {
                    this.checkTips( "提现金额不得小于100且为整10的倍数", 'warning' );
                    return
                }
                if (!this.password) {
                    this.checkTips( "请填写支付密码", 'warning' );
                    return
                }
                this.is_butClick = true
                let params = {PayPwd: this.password}
                this.$api.product.VerifyPayPwd(params).then((res) => {
                    if ( res.data.code == 0 )
                    {
                        this.UserCashOut()
                    }else
                    {
                        let name = res.data.message;
                        this.checkTips( name, 'warning' );
                        this.is_butClick = false
                    }
                })
            },
            UserCashOut() {
                console.log(this.bankObj)
                // 旧版
                // let params = {
                //     price: Number(this.money),
                //     poundage_money: 10,
                //     bank_id: this.bankObj.bank_id,
                //     bank_no: this.bankObj.cardno,
                //     bank_name: this.bankObj.cardname,
                // }
                // 新版
                let params = {
                    price: Number(this.money),
                    poundage_money: 10,
                    u_bank_id: this.bankObj.id
                }
                this.$api.product.UserCashOut(params).then((res) => {
                    if ( res.data.code == 0 )
                    {
                        this.is_Popup = true
                        // this.$confirm('提现已成功，是否继续提现？', '温馨提示', {
                        //     confirmButtonText: '确定',
                        //     cancelButtonText: '取消',
                        //     type: 'warning'
                        // }).then(() => {
                        //     this.getBalance()
                        //     this.is_butClick = false
                        //     this.money = ''
                        //     this.password = ''
                        // }).catch(() => {
                        //     this.routerTxClick()
                        // });
                    }else
                    {
                        let name = res.data.message;
                        this.is_butClick = false
                        this.checkTips( name, 'warning' );
                    }
                })
            },
            readFn() {
                this.getBalance()
                this.is_Popup = false
                this.is_butClick = false
                this.money = ''
                this.password = ''
            },
            checkTips( name, type )
            {
                this.$message(
                {
                    message: name,
                    type: type
                } );
            },
            routerTxClick() {
                localStorage.setItem( 'titleActValue', 3 );
                this.closeaddress()
            },
            // +--------------------------------------
            closeaddress(bol)
            {
                this.$emit( 'childFn', bol )
            }

        }
    }
</script>